import React from 'react';
import * as styles from './detailedCurriculum.module.scss';

const DSA = ['DSA-101 · Beginner DSA — 4 weeks', 'DSA-102 · Problem-solving foundations — 4 weeks', 'DSA-201 · Intermediate DSA — 4 weeks', 'DSA-202 · Trees, graphs & recursion — 4 weeks', 'DSA-203 · Advanced DSA & DP — 4 weeks'];
const SYSTEM_DESIGN = ['LLD-201 · Low Level Design — Foundations', 'LLD-202 · Low Level Design — Advanced', 'LLD-203 · Machine coding & interview practice', 'HLD-301 · Architecture & high-level design choices', 'HLD-302 · Distributed-system scenarios', 'HLD-303 · Building for scale on the cloud'];

const Modules = () => {
  return (
    <section id="modules">
      <div className={styles.wrap}>
        <h2 className={styles.secH}>
          Optional modules — <span className={styles.g}>included.</span>
        </h2>
        <p className={styles.secSub}>
          Self-paced, on the platform with guided session recordings. Take them alongside the
          sprints or after the program.
        </p>
        <div className={styles.grid2}>
          <div className={styles.tile}>
            <h3>Data Structures &amp; Algorithms</h3>
            <p style={{ marginBottom: 12 }}>300+ problems on the platform with guided session recordings</p>
            <ul>
              {DSA.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>
          <div className={styles.tile}>
            <h3>System Design</h3>
            <p style={{ marginBottom: 12 }}>Low-level and high-level design with hands-on scenarios</p>
            <ul>
              {SYSTEM_DESIGN.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Modules;
